import { render, staticRenderFns } from "./DefButtonPrimary.vue?vue&type=template&id=5068b7d7&scoped=true&"
import script from "./DefButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./DefButtonPrimary.vue?vue&type=script&lang=js&"
import style0 from "./DefButtonPrimary.vue?vue&type=style&index=0&id=5068b7d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068b7d7",
  null
  
)

export default component.exports